module.exports = __webpack_public_path__ + "img/Cleric.1f6311b6.png";